import { ca } from '@cian/analytics';

interface ITrackSendMessageClickParams {
  label: string;
  placeType: string;
}

export function trackSendMessageClick({ label, placeType }: ITrackSendMessageClickParams) {
  ca('eventSite', {
    action: 'send_message',
    category: 'CardJK',
    label,
    name: 'oldevent',
    useLastProducts: true,
    page: {
      extra: {
        type: placeType,
      },
    },
  });
}
